import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    AP_AND_IB_TIME_PEROID_CLASSES_LIST_START: "AP_AND_IB_TIME_PEROID_CLASSES_LIST_START",
    AP_AND_IB_TIME_PEROID_CLASSES_LIST_SUCCESS: "AP_AND_IB_TIME_PEROID_CLASSES_LIST_SUCCESS",
    AP_AND_IB_TIME_PEROID_CLASSES_LIST_FAILED: "AP_AND_IB_TIME_PEROID_CLASSES_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const apIbClassesListStart = (data) => ({
    type: actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_START,
    payload: data,
});

export const apIbClassesListSuccess = (data) => ({
    type: actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_SUCCESS,
    payload: data,
});

export const apIbClassesListFailed = (data) => ({
    type: actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function apIbClassesListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* apIbTimePeroidListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allapIbClasses =  response.data.data.allApandibclassestimeperiods.Apandibclassestimeperiods
            yield put(apIbClassesListSuccess(allapIbClasses));
        } else {
            messagePopup("", "Ap/Ib classes List failed", "error");
            yield put(apIbClassesListFailed("Ap/Ib classes  List failed"));
        }
    } catch (error) {
        messagePopup("", "Ap/Ib classes List failed", "error");
        yield put(apIbClassesListFailed("Ap/Ib classes  List failed"));
    }
}

export function* watchApIbClassesTimePeroidListSaga() {
    yield takeEvery(actionType.AP_AND_IB_TIME_PEROID_CLASSES_LIST_START, apIbTimePeroidListSaga);
}
